<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New User {{ (inputUsername) ? (" - " + this.inputUsername) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && $attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View User - {{this.inputUsername}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit User - {{this.inputUsername}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="userFormMode == 1" style="padding-bottom: 12%;"> 
                <div>
                    <a-steps :current="current" style='border-bottom: 1px solid #e0e0e0;' class="py-2" size="small">
                        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                    </a-steps>
                    <div class="steps-content">
                        <div v-if="current == 0" >
                            <div class="pt-3" style='border-bottom: 1px solid #e0e0e0;'>
                                <p class="h4">Enter User Information</p>
                                <!-- TODO: ???? -->
                                <p style="line-height: 90%;"><small>Fill out the fields below to create a new user</small></p>
                            </div>
                            <div style='border-bottom: 1px solid #e0e0e0;'>
                                <div class="row mt-1">
                                    <div class="col">
                                        <base-input alternative="" label="Last Name" placeholder="" v-model="inputLastName" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                    </div>
                                    <div class="col">
                                        <base-input alternative="" label="First Name" placeholder="" v-model="inputFirstName" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                    </div>
                                </div>
                                <base-input class="mb-0" alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                <base-input class="mt-3 mb-0" alternative="" label="Employee Id" placeholder="" v-model="inputEmployeeId" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                <base-input class= 'mt-3 mb-0' alternative="" label="Username" placeholder="" v-model="inputUsername" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                <base-input class= 'mt-3 mb-0' alternative="" label="Email" placeholder="" v-model="inputEmail" input-classes="form-control" :disabled="this.$attrs.viewMode"/>
                                <base-input class="mt-3 mb-0"  aria-describedby="password-help" alternative="" label="Password" placeholder="" type="password" v-model="inputPassword" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                <b-form-text v-if="userPasswordFormatStrict"  id="password-help" v-html="passwordValidationLabel"></b-form-text>
                                <b-form-text v-else  id="password-help">Limited to 6-15 alphanumeric characters only</b-form-text>
                                <base-input  class="mt-3"  alternative="" label="Confirm Password" placeholder="" type="password" v-model="inputConfirmPassword" input-classes="form-control" required/>
                                <base-input v-if="onPasswordExpiration" label="Password Expiration Date" class="mt-3">
                                    <br><a-date-picker v-model="inputPasswordExpire" :format="dateFormat"/>
                                </base-input>
                                <base-input label="Expiry Date" class="mt-3">
                                    <br><a-date-picker v-model="inputExpire" :format="dateFormat"/>
                                </base-input>
                                <p v-if="isSystem == true" class="h4 mt-3"><i class="fas fa-laptop-code"></i> System User</p>
                            </div>
                            <div class="mt-1 row">
                                <div class="col">
                                    <p class="h4 text-muted">User Locked on Suspected Forced Entry <a-switch class='float-right' @change="switchToggle" :checked="isLocked" :disabled="switchDisabled" style="margin-bottom:5px"/></p>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col">
                                    <p class="h4 text-muted">Allow User to Access Sensitive Customer Data <a-switch class='float-right' @change="switchToggle" :checked="inputCustomerAccess" style="margin-bottom:5px"/></p>
                                </div>
                            </div> -->
                        </div>
                        <div v-if="current == 1" >
                            <div class="pt-3" style='border-bottom: 1px solid #e0e0e0;'>
                                <p class="h4">Assign User Groups</p>
                                <p style="line-height: 80%;"><small>Select checkboxes to assign groups to this user. Users belonging to multiple user groups will have the access rights of the most superior group applied to them.</small></p>
                            </div>
                            <div style='border-bottom: 1px solid #e0e0e0;' >
                                <div v-for="userGroup in userGroups" :key="userGroup.id">
                                    <li class="list-group-item" style="font-size: 14px; background-color: #f7f7f7; border-radius: 0;" >
                                        <div class="row" >
                                            <div class="col-md-6">
                                            {{userGroup.name}}
                                            </div>
                                            <div class="col-md-6">
                                                <a-checkbox v-if="serverType == 'ho'" @change="onCheckUserGroup(userGroup.id)"  :checked="selectedUserGroups.includes(userGroup.id)" class="float-right" :disabled="$attrs.viewMode"/>
                                                <a-checkbox v-else @change="onCheckUserGroup(userGroup.id)"  :checked="selectedUserGroups.includes(userGroup.id)" class="float-right" disabled/>
                                            </div>
                                        </div>
                                    </li>
                                </div>
                                <br><br>
                            </div>
                        </div>
                        <div v-if="current == 2" >
                            <div class="pt-3" style='border-bottom: 1px solid #e0e0e0;'>
                                <p class="h4">Add Site Access</p>
                                <p style="line-height: 90%;"><small>Select sites that user can access. After selection, you may set the user's default site</small></p>
                            </div>
                            <div class="mt-1 row" v-if="serverType == 'ho'" >
                                <div class="col">
                                    <p class="h4 text-bold">Give User Access to All Sites <a-switch class='float-right' @change="switchToggleAllSites" :checked="selectAllSites" style="margin-bottom:5px" :disabled="profileId != 0 && $attrs.viewMode == true"/></p>
                                </div>
                            </div>
                            <div class="py-2" style='border-bottom: 1px solid #e0e0e0; border-top: 1px solid #e0e0e0;' v-if="selectAllSites == false">
                                <template v-if="serverType == 'ho'">
                                    <!-- site products location tagging -->
                                    <div class="col-md-8">
                                        <!-- 
                                                    * selected row keys accepts parents key 
                                                    * parent_key change to location name which is string .
                                                    * filter selected row keys to remove string which is the parent key on create and update method 
                                                -->
                                        <a-input
                                            v-model="searchTerm"
                                            placeholder="Search..."
                                            class="custom-input ml-3"
                                        />
                                        <a-tree
                                            checkable
                                            :defaultCheckedKeys="selectedSites"
                                            :defaultExpandedKeys="expandedKeys"
                                            :treeData="filteredTreeData"
                                            :disabled="profileId !== 0 && $attrs.viewMode"
                                            @check="selectSites"
                                            @expand="handleExpand"
                                        />
                                    </div>
                                    <!-- end site products location tagging -->
                                </template>
                                <template v-else>
                                    <!-- <a-select optionFilterProp="label"  mode="multiple" @change="selectSites" :value="selectedSites" style="width: 100%" placeholder="Enter site name or select from list" disabled>
                                            <a-select-option v-for="site in filteredSites" :key="site.id" :label="site.name" :value="site.id">{{site.name}}</a-select-option>
                                        </a-select> -->
                                    <!-- site products location tagging -->
                                    <div class="col-md-8">
                                        <!-- 
                                                    * selected row keys accepts parents key 
                                                    * parent_key change to location name which is string .
                                                    * filter selected row keys to remove string which is the parent key on create and update method 
                                                -->
                                        <a-input
                                            v-model="searchTerm"
                                            placeholder="Search..."
                                            class="custom-input"
                                        />
                                        <a-tree
                                            checkable
                                            :defaultCheckedKeys="selectedSites"
                                            :defaultExpandedKeys="expandedKeys"
                                            :treeData="filteredTreeData"
                                            :disabled="profileId !== 0 && $attrs.viewMode"
                                            @check="selectSites"
                                            @expand="handleExpand"
                                        />
                                    </div>
                                    <!-- end site products location tagging -->
                                </template>
                            </div>
                            <div style='border-bottom: 1px solid #e0e0e0;' class="pt-3">
                                <p class="h4">Home Branch</p>
                                <div v-for="site in sites" :key="site.id">
                                    <li class="list-group-item my-2" style="font-size: 14px; background-color: #f7f7f7;" v-if="selectedSites.includes(site.id)">
                                        <div class="row">
                                            <div class="col-md-6">
                                                {{site.name}}
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-radio v-if="serverType == 'ho'" class="float-right" v-model="selectedSite" name="selectedSite" @change="selectASite" :value="site.id" :disabled="profileId != 0 && $attrs.viewMode == true"/>
                                                <b-form-radio v-else class="float-right" v-model="selectedSite" name="selectedSite" @change="selectASite" :value="site.id" disabled/>
                                            </div>
                                        </div>
                                    </li>
                                </div>
                            </div>
                            <br><br>
                        </div>
                    </div>
                </div>
                
                    
            </div>
            <div v-else-if="userFormMode == 2" style="padding-bottom: 12%;">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: userForm.mode, groups: userForm.groups}" :formSettings="userData" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-else style="padding-bottom: 12%;">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <div >
                            <a-steps :current="current" style='border-bottom: 1px solid #e0e0e0;' class="py-2" size="small">
                                <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                            </a-steps>
                            <div class="steps-content">
                                <div v-if="current == 0" >
                                    <div class="pt-3" style='border-bottom: 1px solid #e0e0e0;'>
                                        <p class="h4">Enter User Information</p>
                                        <p style="line-height: 90%;"><small>Fill out the fields below to create a new user</small></p>
                                    </div>
                                    <div class="py-2" style='border-bottom: 1px solid #e0e0e0;'>
                                        <div class="row">
                                            <div class="col">
                                                <base-input alternative="" label="Last Name" placeholder="" v-model="inputLastName" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                            </div>
                                            <div class="col">
                                                <base-input alternative="" label="First Name" placeholder="" v-model="inputFirstName" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                            </div>
                                        </div>

                                        <base-input class="mb-0" alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                        <base-input class="mt-3 mb-0" alternative="" label="Employee Id" placeholder="" v-model="inputEmployeeId" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>

                                        <base-input class= 'mt-3 mb-0' alternative="" label="Username" placeholder="" v-model="inputUsername" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>

                                        <base-input class= 'mt-3 mb-0' alternative="" label="Email" placeholder="" v-model="inputEmail" input-classes="form-control" :disabled="this.$attrs.viewMode"/>


                                        <base-input class="mt-3 mb-0"  aria-describedby="password-help" alternative="" label="Password" placeholder="" type="password" v-model="inputPassword" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                        <b-form-text v-if="userPasswordFormatStrict"  id="password-help" v-html="passwordValidationLabel"></b-form-text>
                                        <b-form-text v-else  id="password-help">Limited to 6-15 alphanumeric characters only</b-form-text>
                                        <base-input  class="mt-3"  alternative="" label="Confirm Password" placeholder="" type="password" v-model="inputConfirmPassword" input-classes="form-control" :disabled="this.$attrs.viewMode" required/>
                                        <base-input v-if="onPasswordExpiration" label="Password Expiration Date" class="mt-3">
                                            <br><a-date-picker v-model="inputPasswordExpire" :format="dateFormat"/>
                                        </base-input>
                                        <base-input class='mt-3' label="Expiry Date">
                                            <br><a-date-picker v-model="inputExpire" :format="dateFormat" :disabled="this.$attrs.viewMode"/>
                                        </base-input>

                                        <p v-if="isSystem == true" class="h4 mt-3"><i class="fas fa-laptop-code"></i> System User</p>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col">
                                            <p class="h4 text-muted">User Locked on Suspected Forced Entry <a-switch class='float-right' @change="switchToggle" :checked="isLocked" :disabled="switchDisabled" style="margin-bottom:5px"/></p>
                                        </div>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col">
                                            <p class="h4 text-muted">Allow User to Access Sensitive Customer Data <a-switch class='float-right' @change="switchToggle2" :checked="inputCustomerAccess" style="margin-bottom:5px"/></p>
                                        </div>
                                    </div> -->
                                </div>
                                <div v-if="current == 1" >
                                    <div class="pt-3" style='border-bottom: 1px solid #e0e0e0;'>
                                        <p class="h4">Assign User Groups</p>
                                        <p style="line-height: 80%;"><small>Select checkboxes to assign groups to this user. Users belonging to multiple user groups will have the access rights of the most superior group applied to them.</small></p>
                                    </div>
                                    <div style='border-bottom: 1px solid #e0e0e0;' >
                                        <div v-for="userGroup in userGroups" :key="userGroup.id">
                                            <li class="list-group-item" style="font-size: 14px; background-color: #f7f7f7; border-radius: 0;" >
                                                <div class="row" >
                                                    <div class="col-md-6">
                                                    {{userGroup.name}}
                                                    </div>
                                                    <div class="col-md-6">
                                                        <a-checkbox v-if="serverType == 'ho'" @change="onCheckUserGroup(userGroup.id)"  :checked="selectedUserGroups.includes(userGroup.id)" class="float-right" :disabled="$attrs.viewMode"/>
                                                        <a-checkbox v-else @change="onCheckUserGroup(userGroup.id)"  :checked="selectedUserGroups.includes(userGroup.id)" class="float-right" disabled/>
                                                    </div>
                                                </div>
                                            </li>
                                        </div>
                                        <br><br>
                                    </div>
                                </div>
                                <div v-if="current == 2" >
                                    <div class="pt-3" style='border-bottom: 1px solid #e0e0e0;'>
                                        <p class="h4">Add Site Access</p>
                                        <p style="line-height: 90%;"><small>Select sites that this user can access. After selection, you may set the user's default site</small></p>
                                    </div>
                                    <div class="py-2" style='border-bottom: 1px solid #e0e0e0;'>
                                        <template v-if="serverType == 'ho'">
                                            <!-- site products location tagging -->
                                            <div class="col-md-8">
                                                <!-- 
                                                            * selected row keys accepts parents key 
                                                            * parent_key change to location name which is string .
                                                            * filter selected row keys to remove string which is the parent key on create and update method 
                                                        -->
                                                <a-input
                                                    v-model="searchTerm"
                                                    placeholder="Search..."
                                                    class="custom-input"
                                                />
                                                <a-tree
                                                    checkable
                                                    :defaultCheckedKeys="selectedSites"
                                                    :defaultExpandedKeys="expandedKeys"
                                                    :treeData="filteredTreeData"
                                                    :disabled="profileId !== 0 && $attrs.viewMode"
                                                    @check="selectSites"
                                                    @expand="handleExpand"
                                                />
                                            </div>
                                            <!-- end site products location tagging -->
                                        </template>
                                        <template v-else>
                                            <!-- <a-select optionFilterProp="label"  mode="multiple" @change="selectSites" :value="selectedSites" style="width: 100%" placeholder="Enter site name or select from list" disabled>
                                                    <a-select-option v-for="site in filteredSites" :key="site.id" :label="site.name" :value="site.id">{{site.name}}</a-select-option>
                                                </a-select> -->
                                            <!-- site products location tagging -->
                                            <div class="col-md-8">
                                                <!-- 
                                                            * selected row keys accepts parents key 
                                                            * parent_key change to location name which is string .
                                                            * filter selected row keys to remove string which is the parent key on create and update method 
                                                        -->
                                                <a-input
                                                    v-model="searchTerm"
                                                    placeholder="Search..."
                                                    class="custom-input"
                                                />
                                                <a-tree
                                                    checkable
                                                    :defaultCheckedKeys="selectedSites"
                                                    :defaultExpandedKeys="expandedKeys"
                                                    :treeData="filteredTreeData"
                                                    :disabled="profileId !== 0 && $attrs.viewMode"
                                                    @check="selectSites"
                                                    @expand="handleExpand"
                                                />
                                            </div>
                                            <!-- end site products location tagging -->
                                        </template>
                                    </div>
                                    <div style='border-bottom: 1px solid #e0e0e0;' class="pt-3">
                                        <p class="h4">Home Branch</p>
                                        <div v-for="site in sites" :key="site.id">
                                            <li class="list-group-item my-2" style="font-size: 14px; background-color: #f7f7f7;" v-if="selectedSites.includes(site.id)">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        {{site.name}}
                                                    </div>
                                                    <div class="col-md-6">
                                                        <b-form-radio v-if="serverType == 'ho'" class="float-right" v-model="selectedSite" name="selectedSite" @change="selectASite" :value="site.id" :disabled="profileId != 0 && $attrs.viewMode == true"/>
                                                        <b-form-radio v-else class="float-right" v-model="selectedSite" name="selectedSite" @change="selectASite" :value="site.id" disabled/>
                                                    </div>
                                                </div>
                                            </li>
                                        </div>
                                    </div>
                                    <br><br>
                                </div>
                            </div>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Defined Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: 'list', groups: userForm.groups_append}" :formSettings="userData" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>

            </div>


            <div v-if="serverType == 'ho'" style="position: absolute; z-index: 1; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <div class="container mx-0 px-0">
                    <div class="row">
                        <div class="col-auto mr-auto">
                            <b-button size="sm" class='float-md-left' style="margin-left: 8px" @click.prevent="$emit('closeDrawer', null)">
                                Cancel
                            </b-button>
                        </div>
                        <div class="col-auto">
                            <template v-if="current>0">
                                <b-button size="sm" id='prev' style="margin-left: 8px" @click="prevUserFormStep" >
                                    Previous
                                </b-button>
                            </template>
                            <template v-if="current < steps.length - 1">
                                <b-button size="sm" id='next' variant="primary" @click="nextUserFormStep(current)">
                                    Next
                                </b-button>
                            </template>
                            <template v-if="current == steps.length - 1">
                                <b-button v-if="(profileId == 0)" size="sm" variant="primary" @click.prevent="create">
                                    Create User
                                </b-button>
                                <b-button v-else size="sm" variant="primary" @click.prevent="update" :disabled="serverType == 'branch' || $attrs.viewMode == true">
                                    Save
                                </b-button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import { mapState } from 'vuex'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'
import moment from 'moment';
import secureStorage from '../../controllers/secureStorage.js'
var component_x;


const productLocationData = [];
export default {
    components: {
        DynamicForm
    },

    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
        filteredSites(){
            // console.log(o.id)
            return this.sites.filter(o => !this.selectedSites.includes(o.id));
        },
        switchDisabled() {
            if (this.$attrs.viewMode == true){
                return true;
            }else if (this.isLocked) {
                return false;
            } else {
                return true;
            }
        },
        filteredTreeData() {
            return this.filterTree(this.productLocationData, this.searchTerm, this.selectedSites);
        }
    },
    mounted: async function() {
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/User?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

        if(this.isJsonString(accSystemModuleRequest.meta) == true){
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.userFormMode = accSystemModule.form_mode
                }

                if(accSystemModule.customized_forms != undefined){
                    this.userForm = accSystemModule.customized_forms
                }
            }
        }

        this.locationOptions = this.$attrs.locationOptions

        if(this.serverType == 'branch' || this.$attrs.viewMode == true){
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                if (!(elements[i].innerText == 'Next' || elements[i].innerText == 'Previous')) {
                    elements[i].disabled = true;
                }
            }
        }
        component_x = this
        this.userGroups = await HTTPRequest.getRequest(component_x.endPoint + 'user_groups/get_all_user_groups', null)
        // this.sites = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites', null)

        if (component_x.profileId > 0) {
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'users/' + component_x.profileId, null)
            console.log("------*******-------")
            console.log(data);
            this.userData = data
            var user_group_ids = await HTTPRequest.getRequest(component_x.endPoint + 'users/show_user_memberships/?user_id=' + component_x.profileId, null)
            var user_site_ids = await HTTPRequest.getRequest(component_x.endPoint + 'users/show_user_sites/?user_id=' + component_x.profileId, null)

            if (data == undefined) {
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    // component_x.user = data
                    component_x.inputLocation = JSON.parse(data["location_path"])
                    component_x.locationPath = JSON.parse(data["location_path"])
                    // component_x.inputLocation = data["location_id"]
                    component_x.inputCustomerAccess = data["customer_access"]
                    component_x.inputFirstName = data["first_name"]
                    component_x.inputLastName = data["last_name"]
                    component_x.inputCode = data["code"]
                    component_x.inputEmployeeId = data["employee_id"]
                    component_x.inputUsername = data["user_name"]
                    component_x.inputEmail = data["email"]
                    component_x.isSystem = data['is_system']
                    component_x.isLocked = data['is_locked']
                    component_x.invalidAttempts = data['invalid_attempts']
                    if(data['expired_at'] != null){
                        component_x.inputExpire = moment(data['expired_at'])
                    }
                    if(data['password_expiration'] != null || data['password_expiration'] != ''){
                        component_x.inputPasswordExpire = moment(data['password_expiration']) || null
                    }
                    if (user_group_ids["error"] == undefined) {
                        component_x.selectedUserGroups = user_group_ids['user_membership_ids']
                    }
                    if (user_site_ids["error"] == undefined) {
                        if (user_site_ids['site_ids'].includes(data['site_id'])) {
                            component_x.selectedSite =  data['site_id']
                        }
                        if (user_site_ids['mode'] != undefined && user_site_ids['mode'] == 'all'){
                            component_x.selectAllSites = true;
                        }
                        component_x.selectedSites = user_site_ids['site_ids']
                        // for last selected site
                        component_x.selectedSites2 = user_site_ids['site_ids']
                    }
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            }

        }
        component_x.productLocationData =[];
        component_x.productLocationData.children = [];
        component_x.getLocationTreeData();
        this.profileNumber = component_x.profileId
        this.sites = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites', null)
        await this.getAccountSettings();
        this.checkPasswordDuration()
        this.dynamicFormKey++
    },
    data: function(){
        return {
            // LOCATION IMPLEM
            inputLocation: null,
            locationOptions: [],
            locationPath: [],

            // METADATA DYNAMIC FORMS
            userFormMode: 1,
            userForm: {},
            userData: {},
            dynamicFormKey: 0,
            formErrors: [],
            spinning: false,
            current: 0,
            steps: [{
                title: 'Basic'
                }, {
                    title: 'User Group'
                }, {
                    title: 'Site Access'
            }],
            inputLastName: "",
            inputFirstName: "",
            inputCode: "",
            inputEmployeeId: "",
            inputUsername: "",
            profileNumber: 0,
            inputEmail: "",
            inputPassword: "",
            inputConfirmPassword: "",
            inputExpire: null,
            inputPasswordExpire: null,
            dateFormat: 'MM-DD-YYYY',
            isLocked: null,
            invalidAttempts: 0,
            isSystem: false,
            errors: [],
            userGroups: [],
            selectedUserGroups: [],
            sites: [],
            selectedSites: [],
            selectedSite: '',
            selectAllSites: false,
            inputCustomerAccess: false,
            productLocationData: [],
            selectedSites2: [],
            userPasswordFormatStrict: false,
            passwordValidationLabel:"",
            passwordformatValidation:{
                minPasswordLength:6,
                passwordReqOneUppercase:false,
                passwordReqOneLowercase:false,
                passwordReqOneNumber:false,
                passwordReqOneSpecialChar:false,
                passExpDuration:null
            },
            onPasswordExpiration:false,

            searchTerm: '',
            expandedKeys: [],
        }
    },
    watch: {
        inputPassword: function () {
            if(this.userPasswordFormatStrict){
                this.passwordValidationLabel = ""
                if (this.inputPassword.length < this.passwordformatValidation.minPasswordLength) {
                    this.passwordValidationLabel += `Your password needs a minimum of ${this.passwordformatValidation.minPasswordLength} characters. <br>`;
                }
                if (this.passwordformatValidation.passwordReqOneLowercase && this.inputPassword.search(/[a-z]/) == -1) {
                    this.passwordValidationLabel += "Your password needs at least one lower case letter. <br>";
                }
                if (this.passwordformatValidation.passwordReqOneUppercase && this.inputPassword.search(/[A-Z]/) == -1) {
                    this.passwordValidationLabel += "Your password needs at least one upper case letter. <br>";
                }
                if (this.passwordformatValidation.passwordReqOneNumber && this.inputPassword.search (/[0-9]/) == -1) {
                    this.passwordValidationLabel += "Your password needs a number.<br>";
                }
                if (this.passwordformatValidation.passwordReqOneSpecialChar && this.inputPassword.search (/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) == -1){
                    this.passwordValidationLabel += "Your password needs at least one special character.<br>";
                }
            }
        },
    },
    methods: {
        moment,
        async onLocationChange(){
            // alert(this.inputLocation);
            this.locationPath = this.inputLocation
            this.sites = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
            this.selectedSites = this.sites.map(x => x.id)
        },
        updateSettings(newFormSettings, settingsGrouping, errors){
            var formSettingsCopy = this.userData
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if(this.userFormMode == 3) {
                this.errors = errors
            }

            this.userData = mergedHash
        },
        selectASite(e) {
            this.selectedSite = e
        },

        async create_action_history(action) {
            console.log(this.profileNumber)
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                profile_id: this.profileNumber,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'user_action_histories/', null, actionHistoryPayload)
        },
        
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        switchToggle(checked){
            this.isLocked = checked
        },
        switchToggle2(checked){
            this.inputCustomerAccess = checked
        },
        async switchToggleAllSites(checked){
            let lastSelectedSite = this.selectedSites2;
            this.selectAllSites = checked
            if(checked){
                this.sites = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?mode=all', null)
                this.selectedSites = this.sites.map(x => x.id)
            }else{
                this.selectedSites = [] // $4999 uncheck all sites on ui
                // this.selectedSites = lastSelectedSite;
            }
        },
        selectSites(e){
            this.selectedSites = e
        },
        onCheckUserGroup(e){
            if(this.selectedUserGroups.includes(e)){
                var indexValue = this.selectedUserGroups.indexOf(e)
                this.selectedUserGroups.splice(indexValue,1)
            } else {
                this.selectedUserGroups.push(e)
            }
        },
        nextUserFormStep(current) {
            this.validateForm(current)

            if(current == 0 && this.profileId == 0){
                this.validatePassword()
            } else if (current == 0 && this.profileId > 0){
                if(!_.isEmpty(this.inputPassword)){
                    this.validatePassword()
                }
            }

            if(this.errors.length > 0){
                return
            } else {
                this.current++
            }
        },
        prevUserFormStep() {
            this.current--
        },
        companyEndpoint (input) {
            return this.endPoint + '/companies?name=' + input;
        },
        getCompany (group) {
            this.companyName = group.display;
            this.inputCompany = group.value;
        },
        siteTypeEndpoint (input) {
            return this.endPoint + '/site_types?name=' + input;
        },
        getSiteType (group) {
            this.siteTypeName = group.display;
            this.inputSiteType = group.value;
        },
        formattedDisplay (result) {
            return result.name + ' [' + result.code + ']';
        },
        validateForm(current){
            this.errors = [];
            if (current == 0) {
                this.errors.push(ValidateField.required('First Name', this.inputFirstName));
                this.errors.push(ValidateField.alphabetWithSpace('First Name', this.inputFirstName));
                this.errors.push(ValidateField.required('Last Name', this.inputLastName));
                this.errors.push(ValidateField.alphabetWithSpace('Last Name', this.inputFirstName));
                this.errors.push(ValidateField.required('Username', this.inputUsername));
                this.errors.push(ValidateField.charMinAndMax('Username', this.inputUsername, 0, 30));
                this.errors.push(ValidateField.required('User Code', this.inputCode));
                this.errors.push(ValidateField.required('Employee Id', this.inputEmployeeId));
            } else if (current == 1) {
                this.errors.push(ValidateField.isEmpty('User Group', this.selectedUserGroups));
            } else {
                if(this.selectAllSites == false){this.errors.push(ValidateField.isEmpty('Site', this.selectedSites));}
                this.errors.push(ValidateField.isNull('Site', this.selectedSite, "Please select one default site"));
                if(this.selectAllSites == false || this.selectAllSites == true){this.errors.push(ValidateField.arrayContains('Site', this.selectedSites, this.selectedSite));}
            }
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        validatePassword(){
            if(this.userPasswordFormatStrict == true){
                if (this.passwordformatValidation.passwordReqOneUppercase) this.errors.push(ValidateField.upperCaseCharacterRequired('Password', this.inputPassword));
                if (this.passwordformatValidation.passwordReqOneLowercase) this.errors.push(ValidateField.lowerCaseCharacterRequired('Password', this.inputPassword));
                if (this.passwordformatValidation.passwordReqOneNumber) this.errors.push(ValidateField.numericRequired('Password', this.inputPassword));
                if (this.passwordformatValidation.passwordReqOneSpecialChar) this.errors.push(ValidateField.specialCharacterRequired('Password', this.inputPassword));
                this.errors.push(ValidateField.charMinAndMax('Password', this.inputPassword, this.passwordformatValidation.minPasswordLength, 128));
            } else {
                this.errors.push(ValidateField.alphanumeric('Password', this.inputPassword));
                this.errors.push(ValidateField.charMinAndMax('Password', this.inputPassword, 6, 15));
            }
            this.errors.push(ValidateField.required('Password', this.inputPassword));
            this.errors.push(ValidateField.matchData('Password', this.inputPassword, this.inputConfirmPassword));
            this.errors.push(ValidateField.dontMatchData('Username', 'Password', this.inputPassword, this.inputUsername))
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        async getLocationTreeData(){
            // component_x.productLocationData = [];
            // console.log(this.serverType)
            var apiData = await HTTPRequest.getRequest(
                    component_x.endPoint + "sites/get_valid_tree_sites",
                    null
                );
            
            let treeSites = function (data, root) {
                var r = [], o = {};
                data.forEach(function (a) {
                    if (o[a.key] && o[a.key].children) {
                        a.children = o[a.key] && o[a.key].children;
                    }
                    o[a.key] = a;
                    if (a.parent_id === root) {
                        r.push(a);
                    } else {
                        o[a.parent_id] = o[a.parent_id] || {};
                        o[a.parent_id].children = o[a.parent_id].children || [];
                        o[a.parent_id].children.push(a);
                    }
                });
                    return r;
            }(apiData, null);

            treeSites.forEach((el) => {
                component_x.productLocationData.push({
                    id: el.id,
                    key: el.key,
                    title: el.title,
                    children: el.children
                });
            });
            
            
            const RemoveKeyandRenametoID = (object, deleteKey) => {
            // if object
            // delete object[deleteKey];
            if(object["key"] != null){
                if(!object["key"].includes("L",0)){
                object["key"] = parseInt(object["key"]);
                }
            }
            delete object["id"];
            
            Object.values(object).forEach((val) => { 
                if (typeof val !== 'object') return;     
                    RemoveKeyandRenametoID(val, deleteKey);
                })
            }
            

            RemoveKeyandRenametoID(component_x.productLocationData, 'key');

            // sort so that unspecified first
            this.productLocationData.sort((a, b) =>
                a.title < b.title ? -1 : Number(a.title > b.title)
            );

            // console.log(this.productData)
            // end location tagging convert children and parent || tree data for site products
        },
        create: async function() {
            let post_request = []
            let userPayload = []

            let expiry = null
            if(this.inputExpire != null){
                expiry = this.inputExpire.format('YYYY-MM-DD')
            } else {
                expiry = ''
            }

            let location = null
            if(this.inputLocation == null){
                location = null
            } else {
                location = this.inputLocation[this.inputLocation.length -1]
            }

            if(this.selectAllSites){
                this.selectedSites = [this.selectedSite]
            }

            switch(this.userFormMode){
            case 1:
                if(!this.validateForm() && !this.validatePassword()) {
                    userPayload = {
                        user: {
                            user_name: this.inputUsername, 
                            first_name: this.inputFirstName.trim(), 
                            last_name: this.inputLastName.trim(), 
                            email: this.inputEmail,
                            password: this.inputPassword, 
                            site_id: this.selectedSite, 
                            location_id: location, 
                            location_path: JSON.stringify(this.locationPath),
                            user_groups: this.selectedUserGroups, 
                            added_sites: this.selectedSites,
                            expired_at: expiry,
                            code: this.inputCode,
                            employee_id: this.inputEmployeeId, password_expiration:this.inputPasswordExpire
                        }
                    }
                    post_request = await HTTPRequest.postRequest(this.endPoint + 'users' + (this.selectAllSites ? '?access_all_sites=true' : ''), null, userPayload)
                    this.profileNumber = post_request.id
                    this.create_action_history("Create")    
                    if(post_request == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        if(post_request["error"] == undefined){
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
                break;
            case 2:
                if(this.formErrors.length > 0){
                    this.$message['error'](
                        "Cannot create user. Please review your inputs."
                    );
                } else {
                    post_request = await HTTPRequest.postRequest(this.endPoint + 'users/' + (this.selectAllSites ? '?access_all_sites=true' : ''), null, {user: this.userData})
                    this.create_action_history("Create")  
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
                break;
            case 3:
                if(!this.validateForm() && !this.validatePassword()) {
                    var inputUser = {
                        user_name: this.inputUsername, 
                        first_name: this.inputFirstName, 
                        last_name: this.inputLastName, 
                        email: this.inputEmail,
                        password: this.inputPassword, 
                        site_id: this.selectedSite, 
                        location_id: location, 
                        location_path: JSON.stringify(this.locationPath),
                        user_groups: this.selectedUserGroups, 
                        added_sites: this.selectedSites,
                        expired_at: expiry,
                        code: this.inputCode,
                        employee_id: this.inputEmployeeId, password_expiration:this.inputPasswordExpire
                    }
                    var inputUsersKeys = Object.keys(inputUser)
                    Object.keys(this.userData).forEach(function (key) {
                        if(inputUsersKeys.includes(key)){
                            delete this.userData[key]
                        }
                    })

                    userPayload = {
                        user: Object.assign({}, inputUser, this.userData)
                    }

                    if(this.formErrors.length > 0){
                        this.$message['error'](
                            "Cannot create user. Please review your inputs."
                        );
                    } else {
                        post_request = await HTTPRequest.postRequest(this.endPoint + 'users/' + (this.selectAllSites ? '?access_all_sites=true' : ''), null, userPayload)
                        this.create_action_history("Create")  
                        if (post_request == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            if (post_request["error"] == undefined) {
                                this.$emit('refreshPage', event)
                            } else {
                                this.errors = post_request["error"].split(",")
                            }
                        }
                    }
                }
                break;
            }
        },
        update: async function(){
            let component_x = this;
            let put_request = []
            let userPayload = []

            let expiry = null
            if(this.inputExpire != null){
                expiry = this.inputExpire.format('YYYY-MM-DD')
            } else {
                expiry = ''
            }

            if(this.isLocked == false){
                this.invalidAttempts = 0
            }

            let location = null
            if(this.inputLocation == null){
                location = null
            } else {
                location = this.inputLocation[this.inputLocation.length -1]
            }
            
            if(this.selectAllSites){
                this.selectedSites = []
            }

            switch(this.userFormMode){
            case 1:
                if(!this.validateForm()) {
                    if(_.isEmpty(this.inputPassword)){
                        userPayload = {
                            user: {
                                user_name: this.inputUsername, 
                                first_name: this.inputFirstName.trim(), 
                                last_name: this.inputLastName.trim(), 
                                email: this.inputEmail, 
                                site_id: this.selectedSite,
                                user_groups: this.selectedUserGroups, 
                                added_sites: this.selectedSites, 
                                is_locked: this.isLocked, 
                                invalid_attempts: this.invalidAttempts,
                                expired_at: expiry,
                                code: this.inputCode, 
                                customer_access: this.inputCustomerAccess, 
                                location_id: location, 
                                location_path: JSON.stringify(this.locationPath), password_expiration:this.inputPasswordExpire,
                                employee_id: this.inputEmployeeId
                            }
                        }
                    } else {
                        if(!this.validatePassword()){
                            userPayload = {
                                user: {
                                    user_name: this.inputUsername, 
                                    first_name: this.inputFirstName.trim(), 
                                    last_name: this.inputLastName.trim(), 
                                    email: this.inputEmail, 
                                    site_id: this.selectedSite,
                                    password: this.inputPassword, 
                                    user_groups: this.selectedUserGroups, 
                                    added_sites: this.selectedSites, 
                                    is_locked: this.isLocked, 
                                    invalid_attempts: this.invalidAttempts,
                                    expired_at: expiry,
                                    code: this.inputCode,
                                    customer_access: this.inputCustomerAccess, 
                                    location_id: location, 
                                    location_path: JSON.stringify(this.locationPath),
                                    password_expiration:this.inputPasswordExpire,
                                    employee_id: this.inputEmployeeId
                                }
                            }
                        }
                    }
                    
                }
                break;
            case 2:
                userPayload = { user: this.userData }
                break;
            case 3:
                if(!this.validateForm()) {
                    if(_.isEmpty(this.inputPassword)){
                        var inputUser = {
                            user_name: this.inputUsername, 
                            first_name: this.inputFirstName.trim(), 
                            last_name: this.inputLastName.trim(), 
                            email: this.inputEmail, 
                            site_id: this.selectedSite,
                            user_groups: this.selectedUserGroups, 
                            added_sites: this.selectedSites, 
                            is_locked: this.isLocked, 
                            invalid_attempts: this.invalidAttempts,
                            expired_at: expiry, 
                            code: this.inputCode,
                            customer_access: this.inputCustomerAccess, 
                            location_id: location, 
                            location_path: JSON.stringify(this.locationPath),
                            password_expiration:this.inputPasswordExpire,
                            employee_id: this.inputEmployeeId
                        }
                    } else {
                        var inputUser = {
                            user_name: this.inputUsername, 
                            first_name: this.inputFirstName.trim(), 
                            last_name: this.inputLastName.trim(), 
                            email: this.inputEmail, 
                            site_id: this.selectedSite,
                            password: this.inputPassword, 
                            user_groups: this.selectedUserGroups, 
                            added_sites: this.selectedSites, 
                            is_locked: this.isLocked, 
                            invalid_attempts: this.invalidAttempts,
                            expired_at: expiry, 
                            code: this.inputCode,
                            customer_access: this.inputCustomerAccess, 
                            location_id: location, 
                            location_path: JSON.stringify(this.locationPath),
                            password_expiration:this.inputPasswordExpire,
                            employee_id: this.inputEmployeeId
                        }
                    }

                    var inputUserKeys = Object.keys(inputUser)
                    Object.keys(component_x.userData).forEach(function (key) {
                        if(inputUserKeys.includes(key)){
                            delete component_x.userData[key]
                        }
                    })

                    delete component_x.userData["md5_password"]

                    // console.log("-----XXX------");
                    // console.log(this.userData);

                    userPayload = {
                        user: Object.assign({}, inputUser, this.userData)
                    }

                    console.log("-----XXX------");
                    console.log(userPayload);
                }
                break;
            }
            if(this.formErrors.length > 0){
                this.$message['error'](
                    "Cannot update user. Please review your inputs."
                );
            } else {
                put_request = await HTTPRequest.putRequest(this.endPoint + 'users/' + this.profileId + (this.selectAllSites ? '?access_all_sites=true' : ''), null, userPayload)
                // this.create_action_history("Update")
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",")
                    }
                }
            }
        },

        async getAccountSettings(){
            let settings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=accountSettings&status=A', null)
            if(settings.length > 0){
                let AccountSettings = JSON.parse(settings[0].value)
                let passwordFormat = AccountSettings.userPasswordFormatStrict
                if(passwordFormat != undefined){
                    this.userPasswordFormatStrict = passwordFormat
                }
                if (this.userPasswordFormatStrict){
                    if(AccountSettings.minPasswordLength!=undefined){
                        this.passwordformatValidation.minPasswordLength = AccountSettings.minPasswordLength
                    } else {
                        this.passwordformatValidation.minPasswordLength = 6
                    }
                    if(AccountSettings.passwordReqOneUppercase!=undefined){
                        this.passwordformatValidation.passwordReqOneUppercase = AccountSettings.passwordReqOneUppercase
                    }
                    if(AccountSettings.passwordReqOneLowercase!=undefined){
                        this.passwordformatValidation.passwordReqOneLowercase = AccountSettings.passwordReqOneLowercase
                    }
                    if(AccountSettings.passwordReqOneNumber!=undefined){
                        this.passwordformatValidation.passwordReqOneNumber = AccountSettings.passwordReqOneNumber
                    }
                    if(AccountSettings.passwordReqOneSpecialChar!=undefined){
                        this.passwordformatValidation.passwordReqOneSpecialChar = AccountSettings.passwordReqOneSpecialChar
                    }
                    if(AccountSettings.onPasswordExpiration!=undefined){
                        this.onPasswordExpiration = AccountSettings.onPasswordExpiration
                        if(AccountSettings.passExpDuration!=undefined){
                            this.passwordformatValidation.passExpDuration = AccountSettings.passExpDuration
                        }
                    }
                }
            }
        },
        checkPasswordDuration(){
            if(component_x.onPasswordExpiration && this.profileNumber <= 0){
                switch (this.passwordformatValidation.passExpDuration) {
                    case '1w':
                        this.inputPasswordExpire = moment(new Date()).add(7,'days')
                        break;
                    case '1m':
                        this.inputPasswordExpire = moment(new Date()).add(1,'months')
                        break;
                    case '2m':
                        this.inputPasswordExpire = moment(new Date()).add(2,'months')
                        break;
                    case '3m':
                        this.inputPasswordExpire = moment(new Date()).add(3,'months')
                        break;
                    case '6m':
                        this.inputPasswordExpire = moment(new Date()).add(6,'months')
                        break;
                    case '1y':
                        this.inputPasswordExpire = moment(new Date()).add(12,'months')
                        break;
                    default:
                        break;
                }
            }
        },

        filterTree(treeData, searchTerm, selectedKeys) {
            const filteredData = treeData.map((data) => {
                const newData = { ...data };

                if (data.children) {
                  newData.children = this.filterTree(data.children, searchTerm, selectedKeys);
                }

                const isMatch = newData.title.toLowerCase().includes(searchTerm.toLowerCase());
                const isSelected = selectedKeys.includes(newData.key);

                if (isMatch || isSelected) {
                  newData.checked = isSelected;
                  return newData;
                }

                return null;
            }).filter(Boolean); // convent value to Boolean rep and filter null values

            return filteredData;
        },

        handleExpand(expandedKeys) {
        this.expandedKeys = expandedKeys;
        }
    }
}
</script>

<style scoped>

.full-width {
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}
</style>
